<template>
	<div class="animated fadeIn ShippingMethods--ShippingMethods-list">
		<!-- <b-row id="ShippingMethods-header-nav">
			<b-col md="6">
				<h1 id="ShippingMethods-header-nav-txt">shippingMethods List  <records-count :total="pageInfo.totalItems"/></h1>
			</b-col>
			<b-col md="6">
				<div class="buttons-panel">
					<b-button
						@click="add()"
						size="sm"
						title="Add"
						style="float: right;margin-bottom: 5px;"
					>
						<i class="fa fa-plus" aria-hidden="true"></i>
					</b-button>
				</div>
			</b-col>
		</b-row> -->
		<fixed-header
      title="Shipping Methods"
      :records="pageInfo.totalItems"
      hideBackBtn hideNewOfferBtn
    >
      <b-button @click="add()" size="sm" variant="primary">
				<i class="fa fa-plus" aria-hidden="true"></i>
			</b-button>
    </fixed-header>
		<b-row>
			<b-col>
				<div class="card">
					<div class="card-body">
						<grid-component
							isResizable
							isReorderable
							isSortable
							:gridId="gridId"
							:pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
							:itemData="itemData"
							:pageSizes="pageInfo.pageSize"
							:totalItems="pageInfo.totalItems"
							:fields="fields"
							:sortBy="pageInfo.sortBy"
							:sortOrder="pageInfo.sortOrder"
							:sortMethod="sortGrid"
							:onEdit="pushToDetails"
							:onDelete="onDelete"
							:styleCustom="'height: 800px'"
							@getData="onGetData"
							/>
					</div>

				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce } from 'lodash';

import { dateTime} from '@/shared/filters';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
	components: {
		GridSettings,
		GridComponent,
		FixedHeader
  },
  metaInfo: () => ({
    title: 'ShippingMethods',
  }),
	data() {
		return {
			prepareColumnsData,
			filtersVisible: false,
			fields: gridFields,
			gridId: GRID_ID.SHIPPINGMETHODS,
			pageable: {
				pageSizes: GRID_PAGE_SIZES,
			},
      selectedRowItemId: 0,
		};
	},
	computed: {
		...mapState('shippingmethods', ['lastOpenedId']),
		...mapGetters('shippingmethods', [
			'gridList',
			'shippingMethod',
			'pageInfo',
			'selectedItemId',
      'tblLoader'
		]),
		...mapGetters('account', ['gridSettingsById']),
		filterButtonName() {
			return this.filtersVisible ? 'Hide advanced' : 'Advanced';
		},
		emptyMessage: function() {
			return this.searchQuery
				? `No ShippingMethods <span class="text-primary">${this.searchQuery}</span> found`
				: 'No ShippingMethods found';
		},
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
		itemData() {
			if(this.gridList == undefined || this.gridList.length === 0) return [];
			return this.gridList.map((ShippingMethod) => ({ ...ShippingMethod, selected: ShippingMethod.id === this.selectedRowItemId }));
		},
	},
	filters: {
		dateTime,
	},
	methods: {
		...mapMutations('shippingmethods', [
			'setItem'
		]),
		...mapActions('shippingmethods', ['getAll', 'getshippingMethodById', 'sortGrid', 'getPage', 'deleteShippingMethod']),
		...mapActions('account', ['saveGridSettings']),
		async onGetData(params) {
			await this.getAll(params);
		},
		add() {
			this.$router.push({ name: 'ShippingMethods.add' });
		},
		onRowClick(row) {
			/*this.setLastOpenedId(row.dataItem.id);*/
      this.setItem({ resource: 'lastOpenedId', payload: row.dataItem.id });
			this.selectedRowItemId = row.dataItem.id;
			},
		pushToDetails(row) {
			/*this.setLastOpenedId(row.id);*/
      this.setItem({ resource: 'lastOpenedId', payload: row.id });
			this.$router.push({
				name: 'ShippingMethods.edit',
				params: { id: row.id },
			});
		},
		async onDelete(item) {
			const deleteConfirmed = await this.openConfirmBox({ message: `Are you sure you want to delete Shipping Method	 "${item.name}"?` });
			if (deleteConfirmed) {
				const response = await this.deleteShippingMethod(item.id);

				if (response != undefined && response.status == 200) {
					this.getAll({});
				}
				
			}
		},
	},
	watch: {
    gridList() {
			//This function sets the first row as the selected row
			if(this.gridList && this.gridList.length > 0 && !this.lastOpenedId){
				this.selectedRowItemId = this.gridList[0].id;
				const { id, detailsVisible } = this.gridList[0];
			}
		},
	},
  async mounted() {
		if(this.lastOpenedId) {
			this.selectedRowItemId = this.lastOpenedId;
		}
    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    await this.getAll({});
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#ShippingMethods-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#ShippingMethods-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.ShippingMethods {
  &--ShippingMethods-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
